import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import './style/style.scss';
import { getTheme } from './Theme';

import Navigation from './components/Navigation';
import Home from './components/Home';
import About from './components/About';
import Offer from './components/Offer';
import Engines from './components/Engines';
import Contact from './components/Contact';
import Research from './components/Research';
import Media from './components/Media';
import Downloads from './components/Downloads';
import Project from './components/Project';
import Jobs from './components/Jobs';
import Footer from './components/Footer';

const App = () => {
  return (
    <div className={getTheme('container-root')}>
      <div className="content">
        <Router>
          <Navigation />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/About" component={About} />
            <Route exact path="/Offer" component={Offer} />
            <Route exact path="/Engines" component={Engines} />
            <Route exact path="/Research" component={Research} />
            <Route exact path="/Media" component={Media} />
            <Route exact path="/Contact" component={Contact} />
            <Route exact path="/Downloads" component={Downloads} />
            <Route exact path="/Project" component={Project} />
            <Route exact path="/Jobs" component={Jobs} />
          </Switch>
        </Router>
      </div>
      <Footer />
    </div>
  );
};

export default App;
